<form nz-form nz-row [formGroup]="authorizationsForm" class="ppl-p0">
    @if (!isConsumerSelected || mode==='edit'){
    @if(mode==='add') {
    <div class="row pb-3 mt-0" style="width: 100%" role="region" 
    aria-labelledby="step1-header">
        <h1 class="step-header" id="step1-header" tabindex="0">Step 1: Search Consumer</h1>
    </div>

    }
    <div class="row pb-3 mt-0 ml-0" style="width: 100%">
        @if(isAttrAvailable('consumerFirstName')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="consumerFirstName"
                    class="ppl-form-label">{{getAttributes('consumerFirstName').label}}
                    @if(getAttributes('consumerFirstName').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('consumerFirstName')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="consumerFirstName" id="consumerFirstName"
                            placeholder="{{getAttributes('consumerFirstName').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['consumerFirstName'] }" />
                    </div>
                    @if (validationErrors['consumerFirstName']) {
                    <span class="pl-1 error-message">{{validationErrors['consumerFirstName']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('consumerLastName')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="consumerLastName"
                    class="ppl-form-label">{{getAttributes('consumerLastName').label}}
                    @if(getAttributes('consumerLastName').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('consumerLastName')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="consumerLastName" id="consumerLastName"
                            placeholder="{{getAttributes('consumerLastName').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['consumerLastName'] }" />
                    </div>
                    @if (validationErrors['consumerLastName']) {
                    <span class="pl-1 error-message">{{validationErrors['consumerLastName']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('medicaid')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="medicaid"
                    class="ppl-form-label">{{getAttributes('medicaid').label}}
                    @if(getAttributes('medicaid').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('medicaid')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="medicaid" id="medicaid"
                            placeholder="{{getAttributes('medicaid').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['medicaid'] }" />
                    </div>
                    @if (validationErrors['medicaid']) {
                    <span class="pl-1 error-message">{{validationErrors['medicaid']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('consumerPPLId')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="consumerPPLId"
                    class="ppl-form-label">{{getAttributes('consumerPPLId').label}}
                    @if(getAttributes('consumerPPLId').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('consumerPPLId')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="consumerPPLId" id="consumerPPLId"
                            placeholder="{{getAttributes('consumerPPLId').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['consumerPPLId'] }" />
                    </div>
                    @if (validationErrors['consumerPPLId']) {
                    <span class="pl-1 error-message">{{validationErrors['consumerPPLId']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
    </div>
    }
    @if(isConsumerSelected) {
    <div  #consumerInfoRegion tabindex="0" aria-labelledby="step3-header consumer-info-header" class="consumer-info-region">
        <h2 class="step-header" id="step3-header">Step 3: Authorization Details</h2>
        <h3 id="consumer-info-header" class="sub-header">Consumer Info:</h3>
    <div nz-row style="width: 90vw" class="ml-3">
        <div nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <div aria-labelledby="label-medicaid value-medicaid">
                <nz-form-label id="label-firstname" [nzSm]="24" [nzXs]="24" nzFor="consumerFirstName" class="ppl-form-label">
                    {{getAttributes('consumerFirstName').label}}:&nbsp;&nbsp;
                </nz-form-label>
                <nz-form-label id="value-firstname" [nzSm]="24" [nzXs]="24" class="ppl-form-control">
                    {{selectedConsumer.consumerFirstName}}
                </nz-form-label>
                </div>
            </nz-row>

        </div>
        <div nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <div aria-labelledby="label-medicaid value-medicaid">
                <nz-form-label id="label-lastname" [nzSm]="24" [nzXs]="24" nzFor="consumerLastName" class="ppl-form-label">
                    {{getAttributes('consumerLastName').label}}:&nbsp;&nbsp;
                </nz-form-label>
                <nz-form-label id="value-lastname" [nzSm]="24" [nzXs]="24" class="ppl-form-control">
                    {{selectedConsumer.consumerLastName}}
                </nz-form-label>
                </div>
            </nz-row>

        </div>
        <div nz-col nzSpan="12" class="ppl-form-item nz-padding-left">

            <nz-row>
                <div aria-labelledby="label-medicaid value-medicaid">
                <nz-form-label id="label-medicaid" [nzSm]="24" [nzXs]="24" nzFor="medicaid" class="ppl-form-label">
                    {{getAttributes('medicaid').label}}:&nbsp;&nbsp;
                </nz-form-label>
                <nz-form-label id="value-medicaid" [nzSm]="24" [nzXs]="24" class="ppl-form-control">
                    {{selectedConsumer.medicaid}}
                </nz-form-label>
            </div>
            </nz-row>


        </div>
        <div nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <div aria-labelledby="label-medicaid value-medicaid">
                <nz-form-label id="label-pplid" [nzSm]="24" [nzXs]="24" nzFor="consumerPPLId" class="ppl-form-label">
                    {{getAttributes('consumerPPLId').label}}:&nbsp;&nbsp;
                </nz-form-label>
                <nz-form-label id="value-pplid" [nzSm]="24" [nzXs]="24" class="ppl-form-control">
                    {{selectedConsumer.consumerPPLId}}
                </nz-form-label>
                </div>
            </nz-row>
        </div>
        </div>
    </div>
    }

    @if(isConsumerSelected || mode==='edit') {
    @if(mode==='add') {
    <div class="row pb-3 mt-5 mb-3" style="width: 100%; margin-top: 5px">
        <h3 class="sub-header">Auth Details:</h3>
    </div>
    }
    <div class="row" style="width: 100%; margin-left: 0">
        @if (mode==='edit') {
        @if(isAttrAvailable('pplAuth')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="pplAuth"
                    class="ppl-form-label">{{getAttributes('pplAuth').label}}
                    @if(getAttributes('pplAuth').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('pplAuth')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input #firstFormField nz-input formControlName="pplAuth" id="pplAuth"
                            placeholder="{{getAttributes('pplAuth').placeholder}}"
                            [ngClass]="{'error': validationErrors['pplAuth'] }" />
                    </div>
                    @if (validationErrors['pplAuth']) {
                    <span class="pl-1 error-message">{{validationErrors['pplAuth']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        }
        @if(isAttrAvailable('clientAuth')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="clientAuth"
                    class="ppl-form-label">{{getAttributes('clientAuth').label}}
                    @if(getAttributes('clientAuth').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('clientAuth')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="clientAuth" id="clientAuth"
                            placeholder="{{getAttributes('clientAuth').tooltip}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['clientAuth'] }" />
                    </div>
                    @if (validationErrors['clientAuth']) {
                    <span class="pl-1 error-message">{{validationErrors['clientAuth']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('serviceAdminLkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="serviceAdminLkp"
                    class="ppl-form-label">{{getAttributes('serviceAdminLkp').label}}
                    @if(getAttributes('serviceAdminLkp').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>

                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('serviceAdminLkp')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['serviceAdminLkp'] }">
                            <ppl-dropdown-select formControlName="serviceAdminLkp" id="serviceAdminLkp"
                                [options]="svcAdminList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                                [placeholder]="'Select Service Administration'"
                                [arialabel]="getAttributes('serviceAdminLkp').mandatory === 'Y' 
                                ? 'Service Administration, required' 
                                : 'Service Administration'"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['serviceAdminLkp']) {
                    <span class="pl-1 error-message">{{validationErrors['serviceAdminLkp']}}</span>
                    }
                </nz-form-control>

            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('orgName')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="orgName"
                    class="ppl-form-label">{{getAttributes('orgName').label}}
                    @if(getAttributes('orgName').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>

                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('orgName')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['orgName'] }">
                            <ppl-dropdown-select formControlName="orgName" id="orgName" [options]="mcoEntries"
                                [optionLabel]="'orgName'" [optionValue]="'orgId'" [placeholder]="'Select MCO/Agency'"
                                [arialabel]="getAttributes('orgName').mandatory === 'Y' 
                                ? 'MCO/Agency, required' 
                                : 'MCO/Agency'"
                                (selectionChange)="onOrgChange($event)"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['orgName']) {
                    <span class="pl-1 error-message">{{validationErrors['orgName']}}</span>
                    }
                </nz-form-control>

            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('planId')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="planId"
                    class="ppl-form-label">{{getAttributes('planId').label}}
                    @if(getAttributes('planId').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>

                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('planId')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="planId" id="planId" placeholder="Plan ID"
                            [readonly]="true" aria-readonly="true" class="readOnly-field"
                            [ngClass]="{'error': validationErrors['planId'] }" />
                    </div>
                    @if (validationErrors['planId']) {
                    <span class="pl-1 error-message">{{validationErrors['planId']}}</span>
                    }
                </nz-form-control>

            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('serviceCode')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="serviceCode"
                    class="ppl-form-label">{{getAttributes('serviceCode').label}}
                    @if(getAttributes('serviceCode').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('serviceCode')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['serviceCode'] }">
                            <ppl-dropdown-select formControlName="serviceCode" id="serviceCode"
                                [options]="serviceCodesList" [optionLabel]="'description'"
                                [arialabel]="getAttributes('serviceCode').mandatory === 'Y' 
                                ? 'Service Code, required' 
                                : 'Service Code'"
                                [optionValue]="'servicecodeDetailId'" [placeholder]="'Select Service code'"
                                (selectionChange)="serviceCodeChanged($event)"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['serviceCode']) {
                    <span class="pl-1 error-message">{{validationErrors['serviceCode']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('modifierCode1')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="modifierCode1"
                    class="ppl-form-label">{{getAttributes('modifierCode1').label}}
                    @if(getAttributes('modifierCode1').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('modifierCode1')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['modifierCode1'] }">
                            
                        <input nz-input formControlName="modifierCode1" id="modifierCode1" placeholder="Modifier"
                            [readonly]="true" aria-readonly="true" class="readOnly-field"
                            [ngClass]="{'error': validationErrors['modifierCode1'] }" />
                            <!-- <ppl-dropdown-select formControlName="modifierCode1" id="modifierCode1"
                                [options]="modifiersList" [optionLabel]="'code'" [optionValue]="'modifierDetailId'"
                                [placeholder]="'Select Modifier'"></ppl-dropdown-select> -->
                        </div>
                    </div>
                    @if (validationErrors['modifierCode1']) {
                    <span class="pl-1 error-message">{{validationErrors['modifierCode1']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('diagnosisId')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="diagnosisId"
                    class="ppl-form-label">{{getAttributes('diagnosisId').label}}
                    @if(getAttributes('diagnosisId').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-row nz-tooltip [nzTooltipTitle]="getAttributes('diagnosisId')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        @if(this.mode !== 'edit' || actionMode === 'edit'){
                        @if(authorizationsForm.get('diagnosisIdValue')?.value){
                        <p nz-col nzSpan="17" tabindex="0">
                            <span class="sr-only">
                                {{ getAttributes('diagnosisId')?.label }}:
                              </span>
                            {{authorizationsForm.get('diagnosisIdValue')?.value}}</p>
                        }
                        <ppl-button [ariaLabel]="getAttributes('diagnosisId').mandatory === 'Y' ? 
                        'Search Primary Diagnosis Codes, required' :
                        'Search Primary Diagnosis Codes'" 
                        [type]="'button'" label="Search" icon="fa fa-search" [customClass]="'ghost-button'"
                            [iconPosition]="'left'" (click)="openSearchDisgnosisCodePopup('diagnosisId')"></ppl-button>
                        }
                        @else{
                        <input nz-input formControlName="diagnosisIdValue" id="diagnosisIdValue"
                            placeholder="{{getAttributes('diagnosisId').placeholder}}" />
                        }
                    </div>
                    @if (validationErrors['diagnosisId']) {
                    <span class="pl-1 error-message">{{validationErrors['diagnosisId']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('primaryDiagnosisId1')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="primaryDiagnosisId1"
                    class="ppl-form-label">{{getAttributes('primaryDiagnosisId1').label}}
                    @if(getAttributes('primaryDiagnosisId1').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-row nz-tooltip [nzTooltipTitle]="getAttributes('primaryDiagnosisId1')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        @if(this.mode !== 'edit' || actionMode === 'edit'){
                        @if(authorizationsForm.get('primaryDiagnosisId1Value')?.value){
                                <p nz-col nzSpan="17" tabindex="0">
                                  <span class="sr-only">
                                    {{ getAttributes('primaryDiagnosisId1')?.label}}:
                                  </span>
                                  {{ authorizationsForm.get('primaryDiagnosisId1Value')?.value }}
                                </p>
                        }
                        <ppl-button ariaLabel="Search Primary Diagnosis Codes 2" [type]="'button'" label="Search" icon="fa fa-search" [customClass]="'ghost-button'"
                            [iconPosition]="'left'"
                            (click)="openSearchDisgnosisCodePopup('primaryDiagnosisId1')"></ppl-button>
                        }
                        @else{
                        <input nz-input formControlName="primaryDiagnosisId1Value" id="primaryDiagnosisId1Value"
                            placeholder="{{getAttributes('primaryDiagnosisId1').placeholder}}" />
                        }
                    </div>
                    @if (validationErrors['primaryDiagnosisId1']) {
                    <span class="pl-1 error-message">{{validationErrors['primaryDiagnosisId1']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('primaryDiagnosisId2')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label id="label-primaryDiagnosisId2" [nzSm]="10" [nzXs]="24" nzFor="primaryDiagnosisId2"
                    class="ppl-form-label">{{getAttributes('primaryDiagnosisId2').label}}
                    @if(getAttributes('primaryDiagnosisId2').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-row nz-tooltip [nzTooltipTitle]="getAttributes('primaryDiagnosisId2')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        @if(this.mode !== 'edit' || actionMode === 'edit'){
                        @if(authorizationsForm.get('primaryDiagnosisId2Value')?.value){
                        <p nz-col nzSpan="17" tabindex="0">
                            <span class="sr-only">
                                {{ getAttributes('primaryDiagnosisId2')?.label}}:
                              </span>
                              {{authorizationsForm.get('primaryDiagnosisId2Value')?.value}}</p>
                        }
                        <ppl-button ariaLabel="Search Primary Diagnosis Codes 3" [type]="'button'" label="Search" icon="fa fa-search" [customClass]="'ghost-button'"
                            [iconPosition]="'left'"
                            (click)="openSearchDisgnosisCodePopup('primaryDiagnosisId2')"></ppl-button>
                        }
                        @else{
                        <input nz-input formControlName="primaryDiagnosisId2Value" id="primaryDiagnosisId2Value"
                            placeholder="{{getAttributes('primaryDiagnosisId2').placeholder}}" />
                        }
                    </div>
                    @if (validationErrors['primaryDiagnosisId2']) {
                    <span class="pl-1 error-message">{{validationErrors['primaryDiagnosisId2']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('primaryDiagnosisId3')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="primaryDiagnosisId3"
                    class="ppl-form-label">{{getAttributes('primaryDiagnosisId3').label}}
                    @if(getAttributes('primaryDiagnosisId3').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-row nz-tooltip [nzTooltipTitle]="getAttributes('primaryDiagnosisId3')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        @if(this.mode !== 'edit' || actionMode === 'edit'){
                        @if(authorizationsForm.get('primaryDiagnosisId3Value')?.value){
                        <p nz-col nzSpan="17" tabindex="0">
                            <span class="sr-only">
                                {{ getAttributes('primaryDiagnosisId3')?.label}}:
                              </span>
                              {{authorizationsForm.get('primaryDiagnosisId3Value')?.value}}</p>
                        }
                        <ppl-button ariaLabel="Search Primary Diagnosis Codes 4" [type]="'button'" label="Search" icon="fa fa-search" [customClass]="'ghost-button'"
                            [iconPosition]="'left'"
                            (click)="openSearchDisgnosisCodePopup('primaryDiagnosisId3')"></ppl-button>
                        }
                        @else{
                        <input nz-input formControlName="primaryDiagnosisId3Value" id="primaryDiagnosisId3Value"
                            placeholder="{{getAttributes('primaryDiagnosisId3').placeholder}}" />
                        }
                    </div>
                    @if (validationErrors['primaryDiagnosisId3']) {
                    <span class="pl-1 error-message">{{validationErrors['primaryDiagnosisId3']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        <!-- </div> -->
        <!-- <div class="row" style="width: 100%; margin-left: 0">
    </div> -->
        <!-- <div class="row" style="width: 100%; margin-left: 0"> -->
        @if(isAttrAvailable('source')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="source"
                    class="ppl-form-label">{{getAttributes('source').label}}
                    @if(getAttributes('source').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('source')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['source'] }">
                            <ppl-dropdown-select formControlName="source" id="source" [options]="authSourceList"
                                [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                                [arialabel]="getAttributes('source').mandatory === 'Y' 
                                ? 'Auth Source, required' 
                                : 'Auth Source'"                                
                                [placeholder]="'Select Source'"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['source']) {
                    <span class="pl-1 error-message">{{validationErrors['source']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('authFrequencyLkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="authFrequencyLkp"
                    class="ppl-form-label">{{getAttributes('authFrequencyLkp').label}}
                    @if(getAttributes('authFrequencyLkp').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('authFrequencyLkp')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['authFrequencyLkp'] }">
                            <ppl-dropdown-select formControlName="authFrequencyLkp" id="authFrequencyLkp"
                                [options]="authFrequencyTypeList" [optionLabel]="'lkpValueName'"
                                [arialabel]="getAttributes('authFrequencyLkp').mandatory === 'Y' 
                                ? 'Authorization Frequency Type, required' 
                                : 'Authorization Frequency Type'"
                                [optionValue]="'lkpValueName'"
                                placeholder="{{getAttributes('authFrequencyLkp').placeholder}}"
                                (selectionChange)="authFreqChanged()"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['authFrequencyLkp']) {
                    <span class="pl-1 error-message">{{validationErrors['authFrequencyLkp']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(authorizationsForm.get('authFrequencyLkp')?.value === 'Daily'){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="unitsInFormatDaily" class="ppl-form-label">
                    {{getAttributes('unitsInFormatDaily').label}}
                    <span *ngIf="getAttributes('unitsInFormatDaily').mandatory === 'Y'" [attr.aria-label]="'Required'">*</span>
                </nz-form-label>
                <nz-form-control [nzSm]="13" [nzXs]="24" class="ppl-form-control">
                    <div [formGroup]="authorizationsForm">
                        <div nz-row formArrayName="dailyUnits">
                            <ng-container *ngFor="let day of daysOfWeek; let i = index">
                                <div nz-col [nzSm]="3" [nzXs]="24" [formGroupName]="i" class="day-inputs">
                                    <nz-form-label>{{ day }}</nz-form-label>
                                    <input nz-input type=text formControlName="hours" aria-label="Authorized Hours and Minutes HHHHMM Format - Hours Required" class="unit-input"
                                        placeholder="HH" (input)="limitDailyDigits($event)"
                                        (blur)="onInputBlur('hr',$event, i, day)" [ngClass]="getControlClass(i)" />
                                    <div>
                                        <ppl-dropdown-select formControlName="minutes" id="minutes" [options]="minSteps"
                                            [showArrow]="false" [showClearButton]="false" [placeholder]="'MM'" arialabel="Minutes required" aria-label="Authorized Hours and Minutes HHHHMM Format - Minutes, Required"
                                            (selectionChange)="onInputBlur('min',$event, i, day)"></ppl-dropdown-select>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    @if (validationErrors['unitsInFormatDaily']) {
                    <span class="pl-1 error-message">{{validationErrors['unitsInFormatDaily']}}</span>
                    }
                </nz-form-control>
            </nz-row>

        </nz-form-item>
        }
        @else{
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label id="label-unitsInFormat" [nzSm]="10" [nzXs]="24" nzFor="unitsInFormat"
                    class="ppl-form-label">{{getAttributes('unitsInFormat').label}}
                    @if(getAttributes('unitsInFormat').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="6" [nzXs]="24" class="ppl-form-control" style="margin-right: 8px;">
                    <div>
                        <input nz-input type=text formControlName="totalAuthUnitsHrs" id="totalAuthUnitsHrs"
                            placeholder="Authorized Hours" aria-autocomplete="none" aria-label="Authorized Hours and Minutes HHHHMM Format - Hours, required" [ngClass]="{'error': validationErrors['unitsInFormat'] }"
                            (input)="limitDigits($event)" (ngModelChange)="onAuthUnitHrChange($event)" />
                    </div>
                    @if (validationErrors['unitsInFormat']) {
                    <span class="pl-1 error-message">{{validationErrors['unitsInFormat']}}</span>
                    }
                </nz-form-control>
                <nz-form-control [nzSm]="6" [nzXs]="24" class="ppl-form-control">
                    <div>
                        <div>
                            <ppl-dropdown-select formControlName="totalAuthUnitsMin" id="totalAuthUnitsMin"
                                [options]="minSteps" [showArrow]="false" [showClearButton]="false"
                                [placeholder]="'Authorized Minutes'" arialabel="Minutes required" aria-label="Authorized Hours and Minutes HHHHMM Format - Minutes, required"
                            (selectionChange)="onAuthUnitMinChange($event)"></ppl-dropdown-select>
                    </div>
                </div>
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('units')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="units"
                    class="ppl-form-label">{{getAttributes('units').label}}
                    @if(getAttributes('units').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div>
                        <input nz-input formControlName="units" id="units"
                            placeholder="{{getAttributes('units').tooltip}}" [readonly]="true"
                            aria-readonly="true" class="readOnly-field"
                            [ngClass]="{'error': validationErrors['units'] }" />
                    </div>
                    @if (validationErrors['units']) {
                    <span class="pl-1 error-message">{{validationErrors['units']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('unittypeLkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="unittypeLkp"
                    class="ppl-form-label">{{getAttributes('unittypeLkp').label}}
                    @if(getAttributes('unittypeLkp').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>

                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('unittypeLkp')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="unittypeLkp" id="unittypeLkp" placeholder="Unit Type"
                            [ngClass]="{'error': validationErrors['unittypeLkp'] }" />
                    </div>
                    @if (validationErrors['unittypeLkp']) {
                    <span class="pl-1 error-message">{{validationErrors['unittypeLkp']}}</span>
                    }
                </nz-form-control>

            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('dollars')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="dollars"
                    class="ppl-form-label">{{getAttributes('dollars').label}}
                    @if(getAttributes('dollars').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('dollars')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="dollars" id="dollars"
                            placeholder="{{getAttributes('dollars').tooltip}}"
                            [ngClass]="{'error': validationErrors['dollars'] }" />
                    </div>
                    @if (validationErrors['dollars']) {
                    <span class="pl-1 error-message">{{validationErrors['dollars']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('startDate')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="startDate"
                    class="ppl-form-label">{{getAttributes('startDate').label}}
                    @if(getAttributes('startDate').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('startDate')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <ppl-date-picker formControlName="startDate" id="startDate" [showIcon]="true"
                            [placeholder]="getAttributes('startDate').placeholder" dateFormat="mm/dd/yy"
                            [ariaLabel]="getAttributes('startDate').mandatory === 'Y' 
                            ? getAttributes('startDate').label + ', required' 
                            : getAttributes('startDate').label"
                  [readonlyInput]="true" [monthNavigator]="true" [yearNavigator]="true"
                            [yearRange]="'1900:2050'" [disableControl]="disableDate" [iconDisplay]="'input'"
                            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [maxDate]="minStartDate"
                            [styleClass]="validationErrors['startDate'] ? 'error' : ''"></ppl-date-picker>
                    </div>
                    @if (validationErrors['startDate']) {
                    <span class="pl-1 error-message">{{validationErrors['startDate']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('endDate')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="endDate"
                    class="ppl-form-label">{{getAttributes('endDate').label}}
                    @if(getAttributes('endDate').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('endDate')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <ppl-date-picker formControlName="endDate" id="endDate" [showIcon]="true"
                            [placeholder]="getAttributes('endDate').placeholder" dateFormat="mm/dd/yy"
                            [readonlyInput]="true" [monthNavigator]="true" [yearNavigator]="true"
                            [yearRange]="'1900:2050'" [disableControl]="disableDate" [iconDisplay]="'input'"
                            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'" [minDate]="maxEndDate"
                            [ariaLabel]="getAttributes('endDate').mandatory === 'Y' 
                            ? getAttributes('endDate').label + ', required' 
                            : getAttributes('endDate').label" [styleClass]="validationErrors['endDate'] ? 'error' : ''"></ppl-date-picker>
                    </div>
                    @if (validationErrors['endDate']) {
                    <span class="pl-1 error-message">{{validationErrors['endDate']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('carryoverUnits')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="carryoverUnits"
                    class="ppl-form-label">{{getAttributes('carryoverUnits').label}}
                    @if(getAttributes('carryoverUnits').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('carryoverUnits')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <div [ngClass]="{'error': validationErrors['carryoverUnits'] }">
                            <ppl-dropdown-select formControlName="carryoverUnits" id="carryoverUnits" [arialabel]="getAttributes('carryoverUnits').label"
                                [options]="radioOptions" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                                [placeholder]="'Carry Forward Allowed'"></ppl-dropdown-select>
                        </div>
                    </div>
                    @if (validationErrors['carryoverUnits']) {
                    <span class="pl-1 error-message">{{validationErrors['carryoverUnits']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(mode === 'edit'){
        @if(isAttrAvailable('sourceDetail')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="sourceDetail"
                    class="ppl-form-label">{{getAttributes('sourceDetail').label}}
                    @if(getAttributes('sourceDetail').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('sourceDetail')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="sourceDetail" id="sourceDetail"
                            placeholder="{{getAttributes('sourceDetail').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['sourceDetail'] }" />
                    </div>
                    @if (validationErrors['sourceDetail']) {
                    <span class="pl-1 error-message">{{validationErrors['sourceDetail']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('statusLkp')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="statusLkp"
                    class="ppl-form-label">{{getAttributes('statusLkp').label}}
                    @if(getAttributes('statusLkp').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('statusLkp')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="statusLkp" id="statusLkp"
                            placeholder="{{getAttributes('statusLkp').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['statusLkp'] }" />
                    </div>
                    @if (validationErrors['statusLkp']) {
                    <span class="pl-1 error-message">{{validationErrors['statusLkp']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('decisionComments')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="decisionComments"
                    class="ppl-form-label">{{getAttributes('decisionComments').label}}
                    @if(getAttributes('decisionComments').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('decisionComments')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="decisionComments" id="decisionComments"
                            placeholder="{{getAttributes('decisionComments').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['decisionComments'] }" />
                    </div>
                    @if (validationErrors['decisionComments']) {
                    <span class="pl-1 error-message">{{validationErrors['decisionComments']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        @if(isAttrAvailable('decisionBy')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="decisionBy"
                    class="ppl-form-label">{{getAttributes('decisionBy').label}}
                    @if(getAttributes('decisionBy').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('decisionBy')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="decisionBy" id="decisionBy"
                            placeholder="{{getAttributes('decisionBy').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['decisionBy'] }" />
                    </div>
                    @if (validationErrors['decisionBy']) {
                    <span class="pl-1 error-message">{{validationErrors['decisionBy']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('estimatedFirstWeekUnits')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="estimatedFirstWeekUnits"
                    class="ppl-form-label">{{getAttributes('estimatedFirstWeekUnits').label}}
                    @if(getAttributes('estimatedFirstWeekUnits').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('estimatedFirstWeekUnits')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="estimatedFirstWeekUnits" id="estimatedFirstWeekUnits"
                            placeholder="{{getAttributes('estimatedFirstWeekUnits').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['estimatedFirstWeekUnits'] }" />
                    </div>
                    @if (validationErrors['estimatedFirstWeekUnits']) {
                    <span class="pl-1 error-message">{{validationErrors['estimatedFirstWeekUnits']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('estimatedMidWeekUnits')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="estimatedMidWeekUnits"
                    class="ppl-form-label">{{getAttributes('estimatedMidWeekUnits').label}}
                    @if(getAttributes('estimatedMidWeekUnits').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('estimatedMidWeekUnits')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="estimatedMidWeekUnits" id="estimatedMidWeekUnits"
                            placeholder="{{getAttributes('estimatedMidWeekUnits').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['estimatedMidWeekUnits'] }" />
                    </div>
                    @if (validationErrors['estimatedMidWeekUnits']) {
                    <span class="pl-1 error-message">{{validationErrors['estimatedMidWeekUnits']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('estimatedLastWeekUnits')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="estimatedLastWeekUnits"
                    class="ppl-form-label">{{getAttributes('estimatedLastWeekUnits').label}}
                    @if(getAttributes('estimatedLastWeekUnits').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div nz-tooltip [nzTooltipTitle]="getAttributes('estimatedLastWeekUnits')?.tooltip || ''"
                        nzTooltipPlacement="topRight">
                        <input nz-input formControlName="estimatedLastWeekUnits" id="estimatedLastWeekUnits"
                            placeholder="{{getAttributes('estimatedLastWeekUnits').placeholder}}" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode"
                            [ngClass]="{'error': validationErrors['estimatedLastWeekUnits'] }" />
                    </div>
                    @if (validationErrors['estimatedLastWeekUnits']) {
                    <span class="pl-1 error-message">{{validationErrors['estimatedLastWeekUnits']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }

        @if(isAttrAvailable('weeklyAuthUnitsFormatted')){
        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
            <nz-row>
                <nz-form-label [nzSm]="10" [nzXs]="24" nzFor="weeklyAuthUnitsFormatted"
                    class="ppl-form-label">{{getAttributes('weeklyAuthUnitsFormatted').label}}
                    @if(getAttributes('weeklyAuthUnitsFormatted').mandatory === 'Y'){
                    <span [attr.aria-label]="'Required'">*</span>
                    }
                </nz-form-label>
                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                    <div>
                        <input nz-input type=text formControlName="weeklyAuthUnitsFormatted" id="weeklyAuthUnitsFormatted"
                            placeholder="Hours" [readonly]="isEditMode"
                            [class.readOnly-field]="isEditMode" aria-autocomplete="none" [ngClass]="{'error': validationErrors['weeklyAuthUnitsFormatted'] }" />
                    </div>
                    @if (validationErrors['weeklyAuthUnitsFormatted']) {
                    <span class="pl-1 error-message">{{validationErrors['weeklyAuthUnitsFormatted']}}</span>
                    }
                </nz-form-control>
            </nz-row>
        </nz-form-item>
        }
        }
        @if(from !== 'add' && showConsumerMcoPlanId){
            <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                <nz-row>
                    <nz-form-label [nzSm]="10" [nzXs]="24" class="ppl-form-label">Consumer MCO Plan ID</nz-form-label>
                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                        <input nz-input [value]="authData?.consumerMcoPlanId || ''" [readonly]="true"
                            class="readOnly-field" aria-readonly="true" />
                    </nz-form-control>
                </nz-row>
            </nz-form-item>
        }
        @if(isNew && isConsumerSelected) {
            <div class="custom-row">
                @if(!authAdded){
                <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'alt-button'" [iconPosition]="'right'"
                    (click)="onAdd()"></ppl-button>
                }
            </div>
        }
    </div>
    }


</form>
@if(authAdded){
<!-- <ppl-accordion [title]="'Upload Documents'" [isOpen]="true"> -->
<div class="row pb-3 mt-8" style="width: 100%">
    <h4 class="step-header"  id="step4-header" tabindex="0">Step 4: Upload Documents</h4>
</div>
<ppl-file-upload [filedInfo]="filedInfo" [authId]="savedAuthId" [sectionData]="" [entry]="'auth'"
    (filesUpdated)="filesUpdated()" [readonly]="false"></ppl-file-upload>
<!-- </ppl-accordion> -->
}
@if(isNew){
@if (!isConsumerSelected && mode==='add') {
<div class="custom-row">
    <ppl-button label="Search" icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"
        (click)="onConsumerSearch()"></ppl-button>
</div>
<!-- <div class="row">
    <p>* Please search and select a consumer to add an authorization.</p>
</div> -->
@if(showSearchError) {
<p class="pl-1 error-message">Please enter atleast one search criteria.</p>
}
}
}

@if (showConsumersList) {
<div class="row" style="width: 100%" aria-live="polite">
    <h2 class="step-header" id="step2-header" tabindex="-1">Step 2: Select Consumer</h2>
</div>
<div class="table-style">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="gridData"
        [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="true" [rowsToDisplay]="10"
        [loadPage]="true" (gridAction)="action($event)" [actionButtons]="actionButtons">
    </ppl-list-table>
</div>
}

@if(isNew){
<!-- @if(isConsumerSelected) {
<div class="custom-row">
    @if(!authAdded){
    <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'alt-button'" [iconPosition]="'right'"
        (click)="onAdd()"></ppl-button>
    }
</div>
} -->
@if (mode==='edit' && !disableForm) {
<div class="custom-row">
    @if(mode==="edit" ){
    <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="onCancelUpdate()"></ppl-button>
    <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
        (click)="onUpdate()"></ppl-button>
    }
</div>
}

@if (showAddedAuths) {
<div class="row" style="width: 100%">
    <h5>Authorizations Added</h5>
</div>
<div class="table-style">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="authsInSession"
        [disableSelection]="true" [cols]="authCols" [gridTitle]="false" [pagination]="false" [loadPage]="true"
        (gridAction)="action($event)" [actionsToBeHidden]="actionsToBeHidden">
    </ppl-list-table>
</div>
}

}

<div class="filter-panel">
    <ng-template #diagnosisListDialog let-cancel="cancel">
        <ppl-search-add-diagnosis-code (diagnosisCodeSelected)="diagnosisCodeSelected($event)"
            [control]="control"></ppl-search-add-diagnosis-code>
    </ng-template>
</div>